/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Action/Duplicate
 * @desc Button to duplicate
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import type React from 'react';
import type { EntityStateWorkflowActionDuplicateProps } from './types';

export const EntityStateWorkflowActionDuplicate: React.FC<
  EntityStateWorkflowActionDuplicateProps
> = ({ entityStateWorkflow }) => (
  <EntityActionDuplicate entity={entityStateWorkflow} />
);
